import { z } from "zod/v4";

export const AnalyticsProductVariantDtoSchema = z.object({
  uuid: z.uuid().optional(),
  id: z.string(),
  title: z.string().nullish(),
});
export type AnalyticsProductVariantDto = z.infer<
  typeof AnalyticsProductVariantDtoSchema
>;

export const AnalyticsProductDtoSchema = z.object({
  id: z.string(),
  title: z.string().nullish(),
  handle: z.string().nullish(),
  variants: AnalyticsProductVariantDtoSchema.array(),
  image: z.string().nullish(),
  experienceId: z.uuid().optional(),
});
export type AnalyticsProductDto = z.infer<typeof AnalyticsProductDtoSchema>;
